import { useEffect, useRef, useState } from "react";

// Throttled (rAF) scroll position hook to reduce re-renders under heavy scrolling.
const useScrollPosition = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const frameRef = useRef<number | null>(null);
  const pendingRef = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      if (pendingRef.current) return; // one measurement per frame
      pendingRef.current = true;
      frameRef.current = requestAnimationFrame(() => {
        setScrollPosition(window.pageYOffset);
        pendingRef.current = false;
      });
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // inicial
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (frameRef.current) cancelAnimationFrame(frameRef.current);
    };
  }, []);

  return scrollPosition;
};

export default useScrollPosition;
